import * as angular from 'angular';

import SendChatControllerName, { openSendChat } from "../../controllers/chat/sendChat";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import ChatServiceName, { ChatHub, ChatService } from "../../services/chat/chat.service";
import { States } from "../../shared/config/constant.module";
import { apsEnums } from "../../shared/dto/aps.enums";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as _ from "lodash";
import { variance } from 'd3';

let requires = [SendChatControllerName, NavigationServiceName, AuthDataServiceName, ChatServiceName];

export default angular.module('aps.controller.nav', requires)
  .controller('NavCtrl', navController)
  .name;

function navController(
  $stateParams: any,
  $modal: mm.foundation.modal,
  navigationService: NavigationService,
  authDataService: AuthDataService,
  chatService: ChatService,
  $state: angular.ui.IStateService,
  $scope: angular.IScope,
  $timeout: angular.ITimeoutService) {
  var vm = this;
  vm.states = States;
  vm.chatUnreadCount = 0;
  vm.hasCounts = false;
  vm.showPlantPerformanceDashboard = false;

  var sendOpen = false;
  var lastChat = {
    message: ''
  };
  var hub: ChatHub;

  $scope.$on('$destroy', () => {
    if (hub) {
      hub.uninitialize();
    }
  });

  vm.openChatDialog = () => {
    sendOpen = true;
    vm.chatUnreadCount = 0;
    openSendChat({
      shopId: vm.shopId,
      plantId: vm.plantId
    }, $modal).then(data => {
      if (data) {
        lastChat = data;
      }
      sendOpen = false;
    });
  };

  navigationService.getNavigation().then(function (navigation) {
    if (!navigation.selectedPlant) {
      navigation.selectedPlant = _.first(navigation.plants());
    }

    vm.hasCounts = navigation.selectedShop.hasLines;

    vm.plantId = navigation.selectedPlant ? navigation.selectedPlant.id : $stateParams.plantId;

    if (!navigation.selectedShop) {
      navigation.selectedShop = _.first(navigation.shops());
    }
    vm.shopId = navigation.selectedShop ? navigation.selectedShop.id : $stateParams.shopId;

    var selectedRoleLocation = authDataService.getSelectedRoleLocation();
    vm.canSendChat = selectedRoleLocation.hasFlag(apsEnums.RoleFlags.Operator);

    var userId = authDataService.getUserId();
    if (authDataService.isPlantOrAPSIOAdminForCurrentPlant()) {
      vm.canSendChat = true;
    }   

    vm.companyLinks = [
      { text: 'Snapshot', state: States.ADMIN_DASHBOARD, visible: true },
      { text: 'Performance', state: States.PLANT_PERFORMANCE, visible: true },
      { text: 'KPIs', state: States.KPIS, visible: authDataService.isProductionShiftReport() }
    ];    

    vm.plantLinks = [
      { text: 'Snapshot', state: States.PLANT_DASHBOARD },
      { text: 'Ware Loss', state: States.PLANT_WARE_LOSS_DASHBOARD },
      { text: 'Measurements', state: States.MEASURE }
    ];

    vm.shopLinks = [
      { text: 'Dashboard', state: States.DASHBOARD },
      { text: 'Summary', state: States.SHOP_SUMMARY_DASHBOARD },
      { text: 'Shop Ops.', state: States.SHOP_OPERATOR_DASHBOARD },
      { text: 'Counts', state: States.COUNTS_HORIZONTAL },
      // { text: 'Vert. Counts', state: States.COUNTS_VERTICAL },
    ];

    vm.hotEndLinks = [
      { text: 'Flex IS', state: States.FLEX_IS_DETAILS },
    ];

    vm.operatorLinks = [
      { text: 'Cavity Corr.', state: States.COUNTS_CAVITY_CORRELATION },
      { text: 'Cavity Eff.', state: States.COUNTS_CAVITY_EFFICIENCY },
      { text: 'Checklist', state: States.CHECKS },
      { text: 'Linesheet', state: States.LINE_SHEET },      
    ];

    // Temporary - only show the Plant Performance Dashboard icon if the user is assigned to that role
    if (_.find(authDataService.getRoles(), x => x.roleName === 'Plant Performance Dashboard')) {
      vm.showPlantPerformanceDashboard = true;
    }

    hub = chatService.createHub(vm.shopId, (chatAdded: apsViewModels.ChatAdded) => {
      if (sendOpen
        || chatAdded.createdById === userId
        || $state.current.name === States.DASHBOARD
        || lastChat.message === chatAdded.message) {
        return;
      }

      $timeout(() => {
        vm.chatUnreadCount = vm.chatUnreadCount + 1;
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/app/layout/nav/nav.controller.ts